// extracted by mini-css-extract-plugin
module.exports = {"container":"AutoResizeChart_container__2Woa8"};